const {LitElement, html, ref, createRef} = window.globalLit;
import BaseStepElement from './BaseStepElement.js';

customElements.define('fill-step', class FillStepElement extends BaseStepElement {

    selectorRef = createRef();

    render() {
        return html`
                <strong>Fill </strong>
                    <element-selector 
                        .value=${this.value.element}
                        ?readonly=${this.readonly}
                        @selectorchange="${this._onChange.bind(this, 'element')}"></element-selector>
                with value 
                    <input is="autogrow-input" type="text" 
                        placeholder="Value..."
                        .value=${this.value.value || ''}
                        ?readonly=${this.readonly}
                        @input="${this._onChange.bind(this, 'value')}"
                        style="min-width: 50px; width: 50px;"
                        class="step__input bg-primary-subtle text-primary">
        `;
    }
});